<template>
  <div>
    <SkeletonScreen v-if="!isCloseSkeletonScreen" :data="3" />
    <div
      v-if="isCloseSkeletonScreen&&consumer.g_name"
      @click="$downapppop.open"
      class="combination_item"
    >
      <div class="title">
        <h4>{{consumer.g_name}}</h4>
        <p>{{consumer.g_no}}</p>
      </div>
      <p
        :class="['rate', isGoUp(consumer.profit_rate) ? 'to_red' : 'to_green']"
      >{{consumer.profit_rate}}%</p>
    </div>
    <no-result v-if="isCloseSkeletonScreen && !consumer.g_name" title="此用户没有发布内容"></no-result>
  </div>
</template>
<script>
import UserProfilesApi from "@/api/userProfiles/";
import noResult from "@/base/no-result/";
export default {
  name: "UserProfiles",
  components: {
    noResult
  },
  data() {
    return {
      consumer: {},
      isCloseSkeletonScreen: false,
      user_id: parseInt(this.$route.params.id)
    };
  },
  created() {
    this.getConsumerCombination();
  },
  methods: {
    columnListMore() {
      if (this.hasMore) return;
    },
    //用户个人主页  组合
    async getConsumerCombination() {
      let data = await UserProfilesApi.getConsumerCombination(this.user_id);
      if (data) {
        this.consumer = data;
      }
      this.isCloseSkeletonScreen = true;
      this.$emit("scrollRefresh");
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@color-red: #fe484a; //主色
@color-red-high: #c7000a; //特殊情况
@color-green: #0ac890; //主色
@color-blue: #1d88d0; //全文、超链接颜色
@color-gray-small: #f7f7f7; //转发内容背影色

@color-gray-high: #222222;
@color-gray-middle: #636363;
@color-gray-low: #939393;

.border-1px(@color: #ccc, @radius: 0px, @style: solid) {
  position: relative;

  &::after {
    content: "";
    pointer-events: none;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    transform-origin: 0 0;
    border-bottom: 1px @style @color;
    border-radius: @radius;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    @media (min-resolution: 2dppx) {
      width: 200%;
      height: 200%;
      border-radius: @radius * 2;
      transform: scale(0.5);
    }

    @media (min-resolution: 3dppx) {
      width: 300%;
      height: 300%;
      border-radius: @radius * 3;
      transform: scale(0.333);
    }
  }
}

.combination_item {
  padding: 17px 14px;
  display: flex;
  height: 78px;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;

  .title {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    > h4 {
      font-size: 17px;
      color: @color-gray-high;
    }

    > p {
      font-size: 13px;
      color: @color-gray-low;
    }
  }

  .rate {
    font-size: 18px;
  }

  .to_red {
    color: @color-red;
  }

  .to_green {
    color: #0ac890;
  }
}
</style>